import React from "react";

import { StyledFlex } from "./styled";
import type { FlexProps } from "./types";

export const Flex: React.FC<FlexProps> = ({
  children,
  direction = "row",
  wrap = "nowrap",
  justify = "flex-start",
  align = "stretch",
  gap,
  inline = false,
  fullWidth = false,
  fullHeight = false,
  maxWidth,
  className,
  testId,
  ...props
}) => {
  return (
    <StyledFlex
      $direction={direction}
      $wrap={wrap}
      $justify={justify}
      $align={align}
      {...(gap !== undefined && { $gap: gap })}
      $inline={inline}
      $fullWidth={fullWidth}
      $fullHeight={fullHeight}
      {...(maxWidth !== undefined && { $maxWidth: maxWidth })}
      className={className}
      data-testid={testId}
      {...props}
    >
      {children}
    </StyledFlex>
  );
};
